import React, { useState } from 'react'
import { Typography, Modal, Form, Button, Row, Col, Select } from 'antd'
import { Formik, FieldArray } from 'formik'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'

const DisableVendorModal = ({
  trigger,
  onSubmit,
  onClose,
  title,
  initialData,
  vendorsList,
  closeAfterSubmit,
  submitButtonText,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const handleOpenModal = e => {
    e.preventDefault()
    setIsModalVisible(!isModalVisible)
  }

  const buildVendorOptions = data => {
    const selectedIds = new Set(data.map(item => item.vendor_id))
    return vendorsList.map(vendor => ({
      label: vendor.name,
      value: vendor.id,
      disabled: selectedIds.has(vendor.id),
    }))
  }

  return (
    <>
      {React.cloneElement(trigger, {
        onClick: handleOpenModal,
      })}
      <Modal
        visible={isModalVisible}
        footer={null}
        closable={false}
        destroyOnClose
        centered
        onCancel={() => setIsModalVisible(false)}
        maskStyle={{
          background: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(10px)',
        }}
        width="480px"
      >
        <Typography.Title level={3}>{title}</Typography.Title>
        <Formik
          initialValues={{ vendors: [...initialData] }}
          onSubmit={async (...data) => {
            try {
              await onSubmit(...data)
              if (closeAfterSubmit) {
                setIsModalVisible(false)
                if (onClose) onClose()
              }
            } catch (err) {
              /* empty */
            }
          }}
        >
          {({ handleSubmit, values, setFieldValue, initialValues }) => (
            <div className="form__fields-array">
              <Form
                onFinish={handleSubmit}
                initialValues={initialValues}
                layout="vertical"
              >
                <FieldArray
                  name="vendors"
                  render={({ name, push, remove }) => (
                    <>
                      {/* eslint-disable react/no-array-index-key */}
                      {values?.vendors.map((field, index) => (
                        <Row
                          key={index}
                          align="middle"
                          style={{ gap: '10px', marginBottom: '12px' }}
                        >
                          <Col flex={1}>
                            <div className="ant-col ant-form-item-label">
                              <label
                                htmlFor={`${name}[${index}].vendor_id`}
                                title="Vendor"
                              >
                                Vendor
                              </label>
                            </div>
                            <Select
                              placeholder="Select Vendor"
                              value={field.vendor_id || undefined}
                              style={{ width: '100%' }}
                              name={`${name}[${index}].vendor_id`}
                              options={buildVendorOptions(
                                values.vendors.filter((_, i) => i !== index)
                              )}
                              onChange={value => {
                                setFieldValue(`${name}[${index}].vendor_id`, value)
                              }}
                            />
                          </Col>
                          <Col style={{ marginTop: '24px' }}>
                            <Form.Item style={{ marginBottom: 0 }}>
                              <Button
                                icon={<DeleteOutlined />}
                                onClick={() => remove(index)}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      ))}
                      {/* eslint-enable react/no-array-index-key */}
                      <Form.Item style={{ marginTop: '20px', marginBottom: 0 }}>
                        <Button
                          type="dashed"
                          onClick={() => {
                            push({ vendor_id: '' })
                          }}
                          block
                          icon={<PlusOutlined />}
                          disabled={values.vendors.length >= vendorsList.length}
                        >
                          Disable Vendor
                        </Button>
                      </Form.Item>
                    </>
                  )}
                />
                <Row justify="space-between" align="middle" style={{ marginTop: '20px' }}>
                  <Col>
                    <Button onClick={handleOpenModal}>Close window</Button>
                  </Col>
                  <Col>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={
                        values?.vendors.length > 0 &&
                        values.vendors.some(v => !v.vendor_id)
                      }
                    >
                      {submitButtonText || 'Save'}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          )}
        </Formik>
      </Modal>
    </>
  )
}

export default DisableVendorModal
